//#region [IMPORT]

// === THIRD-PARTY
import React, { createContext, useState, useEffect, useRef } from 'react';

// === STYLE ===
import { useTheme } from '@mui/material/styles';
import { TableCell, Chip, IconButton, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// === API ===
import { userRoleCreate, userRoleRemove } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function UserRoles(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { userRoles: user_roles, availableRoles: available_roles, userId: client_id } = props;

  const role_options = available_roles.map((role) => {
    return { label: role.RoleName, value: role.id.toString() };
  });

  //#endregion

  //#region [EFFECT]

  useEffect(() => {}, []);

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleRoleDelete(role_name, role_id_raw) {
    //-----------------------------------------------------------------
    const role_id = parseInt(role_id_raw);

    if ( role_name == 'default' || isNaN(role_id) ) return;

    userRoleRemove( client_id, role_id );
  }

  //-----------------------------------------------------------------
  function handleAddButtonClick(event) {
    //-----------------------------------------------------------------
    setAnchorEl(event.currentTarget);
  };

  //-----------------------------------------------------------------
  function handleRoleSelectClose() {
    //-----------------------------------------------------------------
    setAnchorEl(null);
  };

  //-----------------------------------------------------------------
  function handleRoleSelectAdd(role_id_raw) {
    //-----------------------------------------------------------------
    setAnchorEl(null);
    const role_id = parseInt(role_id_raw);

    if ( isNaN(role_id) ) return;

    userRoleCreate(client_id, role_id)
  };

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function displayTags() {
    //-----------------------------------------------------------------
    return user_roles.map((role) => {
      return (
        <Chip
          key={role.id}
          label={role.RoleName}
          sx={{
            margin: theme.spacing(0.25),
          }}
          size='small'
          onDelete={() => handleRoleDelete(role.RoleName, role.id)}
        />
      );
    });
  }

  //-----------------------------------------------------------------
  function displayRoleSelection() {
    //-----------------------------------------------------------------
    return (
      <div style={{
        display: 'inline-block',
        marginLeft: 'auto',
      }}>
        <IconButton
          aria-label='add-role'
          aria-controls='add-role'
          aria-haspopup='true'
          color='primary'
          disabled={role_options.length === 0}
          onClick={handleAddButtonClick}
        >
          <AddIcon fontSize='small' />
        </IconButton>
        <Menu id='role-menu' anchorEl={anchorEl} keepMounted open={open} onClose={handleRoleSelectClose}>
          {role_options.map((option) => {
            return (
              <MenuItem key={option.value} onClick={() => handleRoleSelectAdd(option.value)}>
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <TableCell sx={{border: 'none', width: '100%', maxWidth: '35%' }} >
        {displayTags()}
        {displayRoleSelection()}
      </TableCell>
    );
  }

  //#endregion

  return display();
}
